export const inLoadingState = networkStatus => networkStatus < 7;
